import { ArrowBack } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import TabelPelaporan from 'examples/Tables/TabelPelaporan';
import { CustomDescrypt } from 'global/func';
import { getDataWithResponse } from 'global/getFunc';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import userStore from 'store/userStore';

const Detail = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const navigate = useNavigate()
    const location = useLocation()
    const locationData = location.state
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const reqPerencanaan = () => {
        setLoading(true)
        addReq()
        getDataWithResponse(
            `/admin-opd/get-tr-perencanaan-opd-2/${tahunAnggaran.ta}/${locationData.kd_pd}`,
            decryptedUser,
            (res) => {
                setData(res)
                setLoading(false)
                console.log(res);
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        );
    }

    useEffect(() => {
        console.log(tahunAnggaran);
        reqPerencanaan();
        // setData(reqData(tahunAnggaran.ta, decodedUser.kd_pd))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Kembali</ArgonTypography>
                        }
                        avatar={
                            <IconButton variant="outlined" onClick={() => navigate(-1)}><ArrowBack /></IconButton>
                        }
                    />
                    <CardContent>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" py={2}>
                            <ArgonTypography variant="h6">Tabel Laporan</ArgonTypography>
                        </ArgonBox>
                        <ArgonBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                        >
                            <TabelPelaporan
                                data={data}
                                loading={loading}
                                baseUrl="/a-pemb/laporan"
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default Detail